import { Edit, ExpandMore, Public, Warning, WarningAmber } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Box, Chip, IconButton, TableCell, TableRow, Tooltip } from "@mui/material";
import { IMaterial } from "../../interfaces";
import { MaterialIdentifiers } from "../Shared/MaterialIdentifiers";
import { MaterialInfo } from "../Shared/MaterialInfo";

export const MaterialUndeliveredTableRow = (
    material: IMaterial,
    onAddDiscrepancy: () => void,
) => {

    const hasDiscrepancy = () => {
        if (material.discrepancy)
            if (material.discrepancy.length > 0)
                return true;

        return false;
    }

    return (
        <TableRow className="material-row material-undelivered-row" key={material.materialId}>
            <TableCell>
                <Accordion elevation={0}>
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                    >
                        <Box width="100%">
                          <s>  <p><strong>{material.l3}</strong></p>
                            <small>{material.l1?.value}</small>
                                <small>{material.l2?.value}</small></s>
                            <small><Chip label="Not delivered" color="error" variant="outlined" size="small" /></small>

                        </Box>
                        <Box display="flex" justifyContent="flex-end" alignItems="center" >
                            {material.statusId === 3 &&
                                <Chip
                                    icon={<Public />}
                                    label="Material Out"
                                    color="warning"
                                    size="small"
                                />
                            }
                            {material.statusId === 1 &&
                                <Chip
                                    icon={<Edit />}
                                    label="Draft"
                                    color="info"
                                    size="small"
                                />
                            }
                        </Box>

                    </AccordionSummary>
                    <AccordionDetails>
                        <MaterialInfo material={material} />
                    </AccordionDetails>
                </Accordion>
            </TableCell>
            <TableCell>
                <s><p>{material.classes}</p></s>
            </TableCell>
            <TableCell>
                <s><p>{material.spareType?.value}</p></s>
            </TableCell>
            <TableCell>
                <MaterialIdentifiers material={material} />
            </TableCell>
            <TableCell>
                <s><p>{material.state?.value}</p></s>
            </TableCell>
            <TableCell>
                <s>   <p>
                    {material.quantity}
                    <span>({material.unitOfQuantity.value})</span>
                </p></s>
            </TableCell>

            <TableCell style={{ textAlign: "center" }}>
                <Tooltip title="Discrepancies">
                    {
                        hasDiscrepancy() ?
                            <IconButton
                                onClick={onAddDiscrepancy}
                                color="error"
                            >
                                <Warning />
                            </IconButton>
                            :
                            <IconButton
                                onClick={onAddDiscrepancy}
                                color="default"
                            >
                                <WarningAmber />
                            </IconButton>
                    }
                </Tooltip>
            </TableCell>
        </TableRow >
    );
}

